module.exports = __webpack_public_path__ + "img/features-1-1024x838.afbd24dc.png";